import getAlert from './getAlert'
import createTasks from './createTasks'
import getHistorial from './getHistorial'
import requestRos from './requestRos'
import updateRos from './updateRos'
import closeAlert from './closeAlert'
import getFalsosPositivos from './getFalsosPositivos'

export const getAlertPromise = getAlert
export const createTasksPromise = createTasks
export const getHistorialPromise = getHistorial
export const requestRosPromise = requestRos
export const updateRosPromise = updateRos
export const closeAlertPromise = closeAlert
export const getFalsosPositivosPromise = getFalsosPositivos
